import * as React from 'react'
import type { SVGProps } from 'react'
const SvgInvoice = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={29}
    height={28}
    fill="none"
    viewBox="0 0 29 28"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16.416 11.375a.875.875 0 0 0-.875-.875h-7a.875.875 0 0 0 0 1.75h7a.875.875 0 0 0 .875-.875M15.25 14.875a.875.875 0 0 0-.876-.875H8.541a.875.875 0 0 0 0 1.75h5.833a.875.875 0 0 0 .875-.875M15.541 17.5a.875.875 0 1 1 0 1.75h-7a.875.875 0 1 1 0-1.75z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.666 25.375h15.167a3.21 3.21 0 0 0 3.208-3.208V15.75a.875.875 0 0 0-.875-.875h-3.792V5.767c0-1.66-1.877-2.626-3.228-1.661l-.204.146c-.91.65-2.144.648-3.06-.005a4.4 4.4 0 0 0-5.1 0 2.64 2.64 0 0 1-3.058.005l-.205-.146c-1.35-.965-3.228 0-3.228 1.661V21a4.375 4.375 0 0 0 4.375 4.375M10.8 5.671a2.65 2.65 0 0 1 3.066 0 4.39 4.39 0 0 0 5.093.005l.204-.146a.292.292 0 0 1 .461.237v16.4c0 .525.127 1.02.35 1.458H7.666A2.625 2.625 0 0 1 5.041 21V5.767c0-.237.268-.375.461-.237l.204.146A4.39 4.39 0 0 0 10.8 5.67m10.574 16.496v-5.542h2.917v5.542a1.458 1.458 0 1 1-2.917 0"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgInvoice
